// Stake Controller

stakeController = function () {
  var _stakePopup = {};
  var _inputController = {};
  var _stakeMultiplier = 1;
  var _winlineCount = 0;
  var _defaultBPL = 0;
  var _gameModeData = {};

  this.dismissPopup = function () {
    gdk.stakePopupVisible(false);
    messageBus.post("game:modal", {});
  };

  this.initialise = function (json) {
    _stakePopup = resourceManager.get(json.popupContainerID);
    if (json.multiplier) {
      _stakeMultiplier = json.multiplier;
    }

    messageBus.post("stake:stakeControllerLoaded", this);
  };

  this.showPopup = function () {
    gdk.getAutoplayObject().reset();
    gdk.stakePopupVisible(true);
    _inputController.disableAll();
    _stakePopup.openDialog(
      this.Stakes,
      _stakeSelectionMadeCallback.bind(this),
      _stakeSelectionCancelledCallback.bind(this)
    );
    messageBus.post("game:modal", { reason: "stakeSelection" });
  };

  this.broadcastCurrentStake = function (mode) {
    let gameMode = _helperGetGameMode(mode);
    _stakeSelectionMadeCallback.bind(this)(
      _gameModeData[gameMode]._selectedStakeIndex,
      "default"
    );
  };

  this.setStakeMultiplier = function (multiplier) {
    _stakeMultiplier = multiplier;
    gdk.setStakeMultiplier(multiplier);

    for (let mode in _gameModeData) {
      if (_gameModeData.hasOwnProperty(mode)) {
        let coinSizes = _gameModeData[mode].coinSizes;
        for (var i = 0; i < coinSizes.length; ++i) {
          _gameModeData[mode]._multipliedStakes[i] =
            _gameModeData[mode]._nonMultipliedStakes[i] * _stakeMultiplier;
        }
      }
    }
  };

  this.hidePopup = function () {
    _stakePopup.forceClose();
    this.dismissPopup();
  };

  this.requestChangeStake = function (newStake, mode) {
    let gameMode = _helperGetGameMode(mode);
    if (
      _winlineCount === 0 ||
      _gameModeData[gameMode]._betPerLine.length === 0
    ) {
      return;
    }

    _stakeSelectionMadeCallback.bind(this)(
      _gameModeData[gameMode]._betPerLine.indexOf(newStake / _winlineCount),
      gameMode
    );
  };

  var _parseGameConfig = function (gameConfigTask) {
    _inputController = resourceManager.getController("inputOverlord");
    _winlineCount = gameConfigTask.data.slotConfig.defaultNumLines;
    _defaultBPL = gameConfigTask.data.slotConfig.defaultAmountPerLine;
    _gameModeData = gameConfigTask.data.slotConfig.gameModes;

    if (_gameModeData) {
      // new mode system
      for (let mode in _gameModeData) {
        if (_gameModeData.hasOwnProperty(mode)) {
          _gameModeData[mode]._nonMultipliedStakes = [];
          _gameModeData[mode]._multipliedStakes = [];
          _gameModeData[mode]._betPerLine = [];
          _gameModeData[mode]._selectedStakeIndex = 0;
          let coinSizes = _gameModeData[mode].coinSizes;
          for (var i = 0; i < coinSizes.length; ++i) {
            let coinSize = coinSizes[i];
            _gameModeData[mode]._nonMultipliedStakes.push(
              coinSize * _winlineCount
            );
            _gameModeData[mode]._multipliedStakes.push(
              coinSize * _winlineCount * _stakeMultiplier
            );
            _gameModeData[mode]._betPerLine.push(coinSize);
          }
        }
      }
    } else {
      // backwards compatibility for older games
      _gameModeData = {
        default: {
          _nonMultipliedStakes: [],
          _multipliedStakes: [],
          _betPerLine: [],
          _selectedStakeIndex: 0,
        },
      };

      for (
        var i = 0;
        i < gameConfigTask.data.slotConfig.coinSizes.length;
        ++i
      ) {
        coinSize = gameConfigTask.data.slotConfig.coinSizes[i];
        _gameModeData.default._nonMultipliedStakes.push(
          coinSize * _winlineCount
        );
        _gameModeData.default_multipliedStakes.push(
          coinSize * _winlineCount * _stakeMultiplier
        );
        _gameModeData.default_betPerLine.push(coinSize);
      }
    }

    if (gameConfigTask.data.slotConfig.promotionActive) {
      _stakeSelectionMadeCallback.bind(this)(
        gameConfigTask.data.slotConfig.coinSizes.indexOf(
          gameConfigTask.data.slotConfig.promotionStake / _winlineCount
        ),
        "default"
      );
    } else {
      _stakeSelectionMadeCallback.bind(this)(
        gameConfigTask.data.slotConfig.coinSizes.indexOf(_defaultBPL),
        "default"
      );
    }
  };

  var _handleRecovery = function (task) {
    let gameMode =
      task.data.previousCommands && task.data.previousCommands.length > 0
        ? task.data.previousCommands[0]
        : "default";
    if (!_gameModeData.hasOwnProperty(gameMode)) {
      gameMode = "default";
    }

    _stakeSelectionMadeCallback.bind(this)(
      _gameModeData[gameMode]._betPerLine.indexOf(task.data.bpl),
      gameMode
    );
  };

  var _onPromotionEnded = function (ev) {
    if (!ev.replayGame) {
      _stakeSelectionMadeCallback.bind(this)(
        _gameModeData.default._betPerLine.indexOf(_defaultBPL),
        "default"
      );
    }
  };

  var _onPlatformSetGameStake = function (stake) {
    this.requestChangeStake(stake, "default");
  };

  // only works for basic mode
  this.isMinStake = function () {
    return _gameModeData.default._selectedStakeIndex === 0;
  };

  // only works for basic mode
  this.isMaxStake = function () {
    return (
      _gameModeData.default._selectedStakeIndex ===
      _gameModeData.default.coinSizes.length - 1
    );
  };

  this.getBaseStake = function (mode) {
    let gameMode = _helperGetGameMode(mode);
    return _gameModeData[gameMode]._nonMultipliedStakes[
      _gameModeData[gameMode]._selectedStakeIndex
    ];
  };

  this.getCurrentStake = function (mode) {
    let gameMode = _helperGetGameMode(mode);
    return _gameModeData[gameMode]._multipliedStakes[
      _gameModeData[gameMode]._selectedStakeIndex
    ];
  };

  this.getSelectedStakeIndex = function (mode) {
    let gameMode = _helperGetGameMode(mode);
    return _gameModeData[gameMode]._selectedStakeIndex;
  };

  this.selectNextStake = function () {
    if (
      _gameModeData.default._selectedStakeIndex >=
      _gameModeData.default.coinSizes.length - 1
    ) {
      return;
    }

    _changeSelectedStake.bind(this)(
      _gameModeData.default._selectedStakeIndex + 1,
      "default"
    );
  };

  this.selectPreviousStake = function () {
    if (_gameModeData.default._selectedStakeIndex <= 0) {
      return;
    }

    _changeSelectedStake.bind(this)(
      _gameModeData.default._selectedStakeIndex - 1,
      "default"
    );
  };

  var _changeSelectedStake = function (selectedStakeIndex, mode) {
    let gameMode = _helperGetGameMode(mode);
    _gameModeData[gameMode]._selectedStakeIndex = selectedStakeIndex;
    gdk.setCurrentBPL(this.CurrentBetPerLine);
    let currentModeStake =
      _gameModeData[gameMode]._multipliedStakes[
        _gameModeData[gameMode]._selectedStakeIndex
      ];
    messageBus.post("stake:stakeChanged", currentModeStake);
  };

  var _stakeSelectionMadeCallback = function (selectedStakeIndex, mode) {
    let gameMode = _helperGetGameMode(mode);
    _changeSelectedStake.bind(this)(selectedStakeIndex, gameMode);
    _inputController.enableAll();
    this.dismissPopup();
  };

  var _stakeSelectionCancelledCallback = function () {
    _inputController.enableAll();
    this.dismissPopup();
  };

  var _helperGetGameMode = function (mode) {
    return mode || "default";
  };

  Object.defineProperty(this, "CurrentStake", {
    get: function () {
      return _gameModeData.default._multipliedStakes[
        _gameModeData.default._selectedStakeIndex
      ];
    },
  });
  Object.defineProperty(this, "BaseStake", {
    get: function () {
      return _gameModeData.default._nonMultipliedStakes[
        _gameModeData.default._selectedStakeIndex
      ];
    },
  });
  Object.defineProperty(this, "CurrentBetPerLine", {
    get: function () {
      return _gameModeData.default._betPerLine[
        _gameModeData.default._selectedStakeIndex
      ];
    },
  });
  Object.defineProperty(this, "CurrentWinLineCount", {
    get: function () {
      return _winlineCount;
    },
  });
  Object.defineProperty(this, "Stakes", {
    get: function () {
      return _gameModeData.default._multipliedStakes;
    },
  });
  Object.defineProperty(this, "SelectedStakeIndex", {
    get: function () {
      return _gameModeData.default._selectedStakeIndex;
    },
  });

  messageBus.subscribe("spinner:GameConfigEvent", _parseGameConfig.bind(this));
  messageBus.subscribe("common:RecoverGame", _handleRecovery.bind(this));
  messageBus.subscribe("common:PromotionEnded", _onPromotionEnded.bind(this));
  messageBus.subscribe(
    "platform:setGameStake",
    _onPlatformSetGameStake.bind(this)
  );
};

resourceManager.registerController("stakeController", function () {
  return new stakeController();
});
